import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { leadsFields } from '../leads.model';

const EmailOptInStatusField = () => {
    const record = useRecordContext();
    if (!record) return null;

    // Email opt-in is determined by whether emailSubscriptionGroupId exists (subscriptionGroupId is deprecated, do not use)
    const emailSubscriptionGroupId = record[leadsFields.emailSubscriptionGroupId];
    const emailOptIn = !!emailSubscriptionGroupId;

    if (emailOptIn) {
        return (
            <Chip
                label="Active"
                color="success"
                size="small"
                sx={{ mt: 1 }}
            />
        );
    }

    return (
        <Chip
            label="Inactive"
            color="default"
            size="small"
            sx={{ mt: 1 }}
        />
    );
};

export default EmailOptInStatusField;
